import React, { useState } from 'react';
import styled from 'styled-components';
import { sizes, colors, helpers, media } from 'styles/variables';
import replacer from 'utils/replacer';
import GO from 'utils/GO';

export default props => {
	const lang = props.pageContext.lang || '';
	let [stats] = useState(require(`data/${lang}_stats`));

	const Wrapper = styled.div`
		display: grid;
		img {
			max-width: 100%;
			width: 100%;
		}
		& > .graph {
			position: relative;
			height: auto;
			width: 100%;
			margin-bottom: ${sizes[2]};
			.graph__number {
				position: absolute;
				transform: translate(-50%, -50%);
				background: #fff;
				border: 2px solid transparent;
				border-radius: 99px;
				font-weight: bold;
				white-space: nowrap;
				${media.notsmall} {
					font-size: 14px;
					padding: 10px 16px;
				}
				${media.small} {
					font-size: 12px;
					padding: 8px 14px;
				}
				&--before {
					${media.notsmall} {
						top: 12.5%;
						left: 10.5%;
					}
					${media.small} {
						top: 11%;
						left: 11%;
					}
					color: ${colors.pink.base};
					border-color: ${colors.pink.base};
				}
				&--after {
					${media.notsmall} {
						top: 62%;
						left: 88%;
					}
					${media.small} {
						top: 60%;
						left: 90%;
					}
					color: ${colors.teal.base};
					border-color: ${colors.teal.base};
				}
			}
		}
		${media.notsmall} {
			grid-template-columns: repeat(2, 1fr);
			grid-gap: ${sizes[2]};
			& > .graph {
				grid-column: span 2;
			}
		}
		${media.small} {
			grid-template-columns: 100%;
		}
	`;

	const Item = styled.div`
		background: ${colors.background[0]};
		border-radius: ${sizes[0]};
		display: grid;
		${media.notsmall} {
			grid-template-rows: auto auto;
			${helpers.shadow};
		}
		${media.small} {
			grid-template-columns: auto 1fr;
			border-top: 1px solid ${colors.background[2]};
			padding: ${sizes[2]} 0;
			font-size: 0.9rem;
		}
	`;

	const Title = styled.div`
		display: grid;
		grid-template-columns: auto 1fr;
		align-items: center;
		grid-gap: ${sizes[1]};
		text-transform: capitalize;
		${media.notsmall} {
			padding: ${sizes[2]};
			border-bottom: 1px solid ${colors.background[2]};
		}
	`;

	const Value = styled.div`
		${media.notsmall} {
			padding: ${sizes[4]} ${sizes[1]};
			text-align: center;
			* {
				display: block;
			}
			*:first-of-type {
				font-size: 2rem;
				font-weight: 600;
				margin-bottom: ${sizes[1]};
			}
			*:last-of-type {
				font-size: 0.9rem;
			}
		}
		${media.small} {
			font-weight: bold;
			text-align: right;
			align-self: center;
			* {
				margin-left: ${sizes[0]};
				display: inline-block;
			}
		}
	`;

	return (
		<>
			<Wrapper>
				{stats.map((item, index) => {
					try {
						let lt = JSON.parse(item.long_subtitle);
						if (props.values.json.metric) {
							item.long_subtitle = lt[0];
						} else {
							item.long_subtitle = lt[1];
						}
					} catch (e) {}
					try {
						let st = JSON.parse(item.short_subtitle);
						if (props.values.json.metric) {
							item.short_subtitle = st[0];
						} else {
							item.short_subtitle = st[1];
						}
					} catch (e) {}
					return (
						<Item key={index}>
							<Title>
								<div>
									<img src={item.image.url} alt={item.title} />
								</div>
								<div>{item.title}</div>
							</Title>
							<Value>
								<div>{replacer(item.value, props.values.json)}</div>
								<div className="--notsmall">{replacer(item.long_subtitle, props.values.json)}</div>
								<div className="--small">{replacer(item.short_subtitle, props.values.json)}</div>
							</Value>
						</Item>
					);
				})}
			</Wrapper>
		</>
	);
};
